export const install = (app) => {
  const copyHtmlToClipboard = (elementId: string) => {
    /* Get the text field */
    const element = document.getElementById(elementId);
    if (!element) {
      return;
    }
    let text;
    if (element instanceof HTMLInputElement) {
      const previousType = element.type;
      element.type = "text";
      element.select();
      element.setSelectionRange(0, 99999);
      text = element.value;
      element.type = previousType;
    } else if ("TABLE" === element.tagName) {
      text = tableToText(element);
    } else {
      text = element.innerText;
    }

    return navigator.clipboard.writeText(text);
  };

  app.config.globalProperties.$copyHtmlToClipboard = copyHtmlToClipboard;
  app.provide("copyHtmlToClipboard", copyHtmlToClipboard);
};

export const tableToText = (element: HTMLElement): string => {
  console.log(element);
  const data = [] as string[];
  const rows = element.querySelectorAll("tr") || [];

  for (let i = 0; i < rows.length; i++) {
    const row = [] as string[];
    const cols = rows[i].querySelectorAll(
      "td:not(.no-print), th:not(.no-print)"
    );

    for (let j = 0; j < cols.length; j++) {
      const column = cols[j] as HTMLElement;
      if ("innerText" in column) {
        row.push(column.innerText.replace(",", ""));
      }
    }

    console.log(row);

    data.push(row.join(","));
  }

  return data.join("\n");
};
